module.exports = __webpack_public_path__ + "static/media/Cash-Moneygrey.4bfa6d10.svg";